import React from "react";
import styled from "styled-components";
import BasicButton from "../BasicButton/BasicButton";
import { RULES, DEFAULT_RULE } from "../../lifeSimulator";
import DraggableFaces from "../DraggableFaces/DraggableFaces";

const AdvancedControlsPane = styled.div`
  position: absolute;
  top: 0%;
  right: 0px;
  /* background-color: #075985ea; */
  background-color: #0c4a64da;
  padding: 1rem;
  transform: var(--transform);

  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  backdrop-filter: blur(4px);
  border-radius: 0 0 0 0.5rem;

  @media (max-width: 550px) {
    right: 0;
  }
`;

const StyledSelect = styled.select`
  border: none;
  outline: none;
  background-color: var(--color-sky-500);
  color: var(--color-sky-50);
  padding: 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;

  @media (hover: hover) {
    &:hover {
      background-color: var(--color-sky-600);
    }
  }

  transition: background-color 0.2s ease;
`;

function RulesSelector({ lifeSim }) {
  const [rule, setRule] = React.useState(DEFAULT_RULE);
  return (
    <StyledSelect
      value={rule}
      onChange={(e) => {
        setRule(e.target.value);
        lifeSim.setRule(e.target.value);
      }}
    >
      {RULES.map(({ name, rule }) => (
        <option key={rule} value={rule}>
          {name}
        </option>
      ))}
    </StyledSelect>
  );
}

const RulesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`;

const RulesLabel = styled.label`
  font-size: 1rem;
  color: var(--color-sky-50);
  padding: 0.5rem 0.5rem 0.5rem 0;
  text-align: center;
`;

function Rules({ lifeSim }) {
  return (
    <RulesWrapper>
      <RulesLabel htmlFor="rules-selector">Ruleset:</RulesLabel>
      <RulesSelector id="rules-selector" lifeSim={lifeSim} />
    </RulesWrapper>
  );
}

const AdvancedButton = styled(BasicButton)`
  position: absolute;
  border-radius: 0 0 0.5rem 0.5rem;
  top: 0%;
  right: 20px;
  font-size: 2rem;
  line-height: 1;
  padding: 0.5rem;
  right: 0;

  border-radius: 0 0 0 0.25rem;
  @media (max-width: 550px) {
  }
`;

function AdvancedControlsButton({ ...props }) {
  return <AdvancedButton {...props}>⛭</AdvancedButton>;
}

const ControlsHeader = styled.span`
  font-size: 1.25rem;
  color: var(--color-sky-50);
  padding: 0;
  text-align: center;
`;

function useKey(key, callback) {
  React.useEffect(() => {
    const handleKey = (event) => {
      if (event.key === key) {
        callback();
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [key, callback]);
}

function AdvancedControls({
  brianMode,
  setBrianMode,
  lifeSim,
  usedFaces,
  setUsedFaces,
  unusedFaces,
  setUnusedFaces,
}) {
  const [showAdvancedControls, setShowAdvancedControls] = React.useState(false);
  useKey("Escape", () => setShowAdvancedControls(false));
  return (
    <>
      <AdvancedControlsButton
        onClick={() => {
          setShowAdvancedControls(!showAdvancedControls);
        }}
      />
      <AdvancedControlsPane
        style={{
          "--transform": showAdvancedControls
            ? "translateY(0%)"
            : "translateY(-110%)",
        }}
      >
        <ControlsHeader>Extra Powerful Controls</ControlsHeader>
        <Rules lifeSim={lifeSim} />
        <DraggableFaces
          usedFaces={usedFaces}
          setUsedFaces={setUsedFaces}
          unusedFaces={unusedFaces}
          setUnusedFaces={setUnusedFaces}
        />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <BasicButton
            style={{ minWidth: "144px" }}
            onClick={() => setBrianMode(!brianMode)}
          >
            {brianMode ? "Exit BRIAN MODE" : "Enter BRIAN MODE"}
          </BasicButton>
          <BasicButton
            style={{ width: "fit-content", alignSelf: "flex-end" }}
            onClick={() => setShowAdvancedControls(false)}
          >
            Close
          </BasicButton>
        </div>
      </AdvancedControlsPane>
    </>
  );
}

export default AdvancedControls;
